module.exports = __webpack_public_path__ + "static/media/creative-agency.1017fceb.png";